"use strict";

import Vue from "vue";
import axios from "axios";
import store from "@/store/";

let config = {
  // Full config:  https://github.com/axios/axios#request-config
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// apply interceptor on response
_axios.interceptors.response.use(
  response => response,
  function (error) {
    Vue.$log.debug("error: " + JSON.stringify(error, null, 2));
    Vue.$log.debug("error.response: " + JSON.stringify(error.response, null, 2));
    store.commit("mHideLongLoader");
    
    if (401 == error.response.status) {
      Vue.$log.debug("token / session expired. Logging out");
      return store.dispatch("doLogout");
    }
    
    if (error.response.status > 0) {
      if (error.response && error.response.data) {
        store.state.errormessage = "";
        Vue.nextTick(function () {
          store.state.errormessage = error.response.data.Message || error.response.data;
          store.dispatch("m_errorLog/createError", store.state.errormessage)
        }, this);
      }
      
      if (!error.response && error.message) {
        Vue.nextTick(function () {
          store.commit("mShowErrorMessage", error.message)
          store.dispatch("m_errorLog/createError", store.state.errormessage)
        }, this);
      }
    }

    return Promise.reject(error);
  }
);

Plugin.install = function (Vue /*, options*/) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
